import type { FetchImplementation } from '@readium/shared';

/** Stored copy of a resource, for offline sessions. */
export type OfflineResourceSource = (url: string) => Promise<Response | undefined>;

export const customFetch = (
  token: string,
  xBookId: string,
  offlineSource?: OfflineResourceSource,
): FetchImplementation => {
  return async (input: RequestInfo | URL, init?: RequestInit): Promise<Response> => {
    if (offlineSource) {
      const url = input instanceof Request ? input.url : input.toString();
      const stored = await offlineSource(url);
      if (stored) return stored;
    }
    init = {
      ...init,
      headers: Object.assign({}, init?.headers ?? {}, { token, 'x-bookid': xBookId }),
    };
    return window.fetch(input, init);
  };
};
